// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__1g7l1"};